import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Calendar } from "./calendar";

type DateSelectProps = React.ComponentProps<typeof PopoverTrigger>;

export function DateSelect({ ...props }: DateSelectProps) {
  return (
    <Popover modal={false}>
      <PopoverTrigger asChild {...props} />
      <PopoverContent>
        <Calendar mode="single" className="w-full" />
      </PopoverContent>
    </Popover>
  );
}
